import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Immutable from "seamless-immutable";
import moment from "moment";
import {
  ConsultationFormValidationSchema,
  ConsultationFormBudgetValidationSchema,
} from "../../../validators";
import {
  ConsultationFormStatus,
  ConsultationFormType,
  ProjectMode,
  ProjectType,
} from "../../../utils/enums";
import ProjectListProbeItem from "./ProjectListProbeItem";
import ProjectListSurveyItem from "./ProjectListSurveyItem";

export class ConsultationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreementAccepted: props.agreementAccepted || false,
      opened: props.isOnlyOneConsultationForms,
    };

    this.toggleOpen = (e) => {
      e.preventDefault();
      this.setState({
        opened: !this.state.opened,
      });
    };

    this.onChangeAgreementAccepted = (e) => {
      this.setState({
        agreementAccepted: e.target.checked,
      });
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.agreementAccepted !== this.props.agreementAccepted) {
      this.setState({
        agreementAccepted: this.props.agreementAccepted,
      });
    }

    if (
      prevProps.isOnlyOneConsultationForms !==
      this.props.isOnlyOneConsultationForms
    ) {
      this.setState({
        opened: this.props.isOnlyOneConsultationForms,
      });
    }
  }
  buttonSubmitEnable() {
    const {
      disabled,
      isResultPublished,
      voted,
      outOfRangeVoteDates,
      status,
      outOfRangeDistricts,
      onlyForLegalAge,
      isLegalAgeUser,
      mode,
      loggedOfficeId,
      officeId,
      loggedUserIsCitizen,
      isAuth,
    } = this.props;
    return (
      !disabled &&
      !isResultPublished &&
      !voted &&
      !outOfRangeVoteDates &&
      status === ConsultationFormStatus.Active &&
      !outOfRangeDistricts &&
      (onlyForLegalAge ? isLegalAgeUser : true) &&
      (mode === ProjectMode.Citizen
        ? isAuth && loggedUserIsCitizen && loggedOfficeId == officeId
        : true)
    );
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }

  getConsultationFormValidationSchema() {
    return this.props.projectType === ProjectType.PublicBudget
      ? ConsultationFormBudgetValidationSchema(this.props)
      : ConsultationFormValidationSchema(this.props);
  }

  setExpandStateItem = (propertyName, action, id) => {
    this.props.onSetExpandStateItem(action, propertyName, id);
  };

  getPropertyName(type, isOld) {
    let propertyName = "";
    switch (type) {
      case ProjectType.Probe: {
        propertyName = !isOld ? "probes" : "oldprobes";
        break;
      }
      case ProjectType.Consultation: {
        propertyName = !isOld ? "consultations" : "oldconsultations";
        break;
      }
      case ProjectType.Survey: {
        propertyName = !isOld ? "surveys" : "oldsurveys";
        break;
      }
      case ProjectType.PublicBudget: {
        propertyName = !isOld ? "budgets" : "oldbudgets";
        break;
      }
      default: {
        propertyName = "";
        break;
      }
    }
    return propertyName;
  }

  renderProbe() {
    let newConsultationForm = Immutable.asMutable(this.props, { deep: true });
    let {
      projectId,
      index,
      isExecuting,
      loggedUserId,
      onSubmit,
      isAuth,
      projectStatus,
      onlyForLegalAge,
      mode,
      modeName,
      loggedOfficeId,
      isLegalAgeUser,
      officeId,
      officeName,
      isOnlyOneOffice,
      resultSummary,
      agreementAcceptedRequired = false,
      agreementAccepted = false,
      stateAgreementAccepted = false,
      projectType,
      scrollToAgreement,
      disabled,
      expand,
      loggedUserIsCitizen = false,
    } = this.props;

    const probe = {
      id: projectId,
      status: projectStatus,
      consultationForms: [newConsultationForm],
      dateFrom: newConsultationForm.voteFrom,
      dateTo: newConsultationForm.voteTo,
      onlyForLegalAge: onlyForLegalAge,
      mode: mode,
      modeName: modeName,
      loggedOfficeId: loggedOfficeId,
      isLegalAgeUser: isLegalAgeUser,
      officeId: officeId,
      officeName: officeName,
      resultSummary: resultSummary,
      agreementAcceptedRequired: agreementAcceptedRequired,
      agreementAccepted: agreementAccepted,
      stateAgreementAccepted:
        stateAgreementAccepted || this.state.agreementAccepted,
      projectType,
      scrollToAgreement: scrollToAgreement || Function.prototype,
    };
    const propertyName = this.getPropertyName(ProjectType.Probe, true);
    const opened = expand[propertyName].some((item) => item === projectId);

    return (
      <ProjectListProbeItem
        key={`star-probe-${index}`}
        {...probe}
        isAuth={isAuth}
        isExecuting={isExecuting}
        loggedOfficeId={loggedOfficeId}
        loggedUserId={loggedUserId}
        loggedUserIsCitizen={loggedUserIsCitizen}
        isOnlyOneOffice={isOnlyOneOffice}
        onSaveProjectVote={onSubmit}
        disabled={disabled}
        opened={opened}
        onSetExpandStateItem={(action, id) =>
          this.setExpandStateItem(propertyName, action, id)
        }
        isPreview={this.props.isPreview}
      />
    );
  }

  renderSurvey() {
    let newConsultationForm = Immutable.asMutable(this.props, { deep: true });
    let {
      projectId,
      prefixName,
      type,
      disabled,
      isResultPublished,
      voted,
      outOfRangeVoteDates,
      outOfRangeDistricts,
      index,
      attachments,
      resultAttachments,
      isExecuting,
      loggedUserId,
      onSubmit,
      isAuth,
      projectStatus,
      onlyForLegalAge,
      mode,
      modeName,
      loggedOfficeId,
      isLegalAgeUser,
      officeId,
      officeName,
      isOnlyOneOffice,
      resultSummary,
      agreementAcceptedRequired,
      agreementAccepted,
      stateAgreementAccepted,
      projectType,
      scrollToAgreement,
      loggedUserIsCitizen = false,
    } = this.props;

    let consultationFormValidationSchema =
      this.getConsultationFormValidationSchema();

    const isVoteButtonEnabled = this.buttonSubmitEnable();
    const survey = {
      id: projectId,
      status: projectStatus,
      consultationForms: [newConsultationForm],
      dateFrom: newConsultationForm.voteFrom,
      dateTo: newConsultationForm.voteTo,
      onlyForLegalAge: onlyForLegalAge,
      mode: mode,
      modeName: modeName,
      loggedOfficeId: loggedOfficeId,
      isLegalAgeUser: isLegalAgeUser,
      officeId: officeId,
      officeName: officeName,
      resultSummary: resultSummary,
      consultationFormValidationSchema: consultationFormValidationSchema,
      prefixName: prefixName,
      type: type,
      disabled: disabled,
      isResultPublished: isResultPublished,
      voted: voted,
      outOfRangeVoteDates: outOfRangeVoteDates,
      outOfRangeDistricts: outOfRangeDistricts,
      index: index,
      loggedUserId: loggedUserId,
      attachments: attachments,
      resultAttachments: resultAttachments,
      isVoteButtonEnabled: isVoteButtonEnabled,
      isExecuting: isExecuting,
      onSubmit: onSubmit,
      agreementAcceptedRequired: agreementAcceptedRequired,
      agreementAccepted: agreementAccepted,
      stateAgreementAccepted:
        stateAgreementAccepted || this.state.agreementAccepted,
      projectType: projectType,
      scrollToAgreement: scrollToAgreement || Function.prototype,
    };

    return (
      <ProjectListSurveyItem
        key={`star-probe-${index}`}
        {...survey}
        isAuth={isAuth}
        isExecuting={isExecuting}
        loggedOfficeId={loggedOfficeId}
        loggedUserId={loggedUserId}
        loggedUserIsCitizen={loggedUserIsCitizen}
        isOnlyOneOffice={isOnlyOneOffice}
        onSaveProjectVote={onSubmit}
        isPreview={this.props.isPreview}
      />
    );
  }

  renderContent() {
    let { type, projectType } = this.props;

    if (
      projectType === ProjectType.Consultation &&
      type === ConsultationFormType.Probe
    ) {
      return this.renderProbe();
    } else if (
      projectType === ProjectType.Consultation &&
      type === ConsultationFormType.Survey
    ) {
      return this.renderSurvey();
    }
  }

  render() {
    let {
      district,
      maxPoint = 0,
      categoryMaxPoint = 0,
      questionMaxPoint = 0,
    } = this.props;
    let { opened } = this.state;

    let points = {
      maxForDistrict: maxPoint,
      maxForCategory: categoryMaxPoint,
      maxForProject: questionMaxPoint,
    };

    return (
      <React.Fragment>
        {this.props.projectType === ProjectType.PublicBudget && (
          <Fragment>
            <div className="consultations__item">
              <div className="consultations__body">
                <div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
                  <div className="consultations__header">
                    <div className="consultations__title consultations__title--center">
                      {district ? district.name : "Ogólnomiejski"}
                    </div>
                    <div className="consultations__icons">
                      <div
                        className="consultations__switch consultations__switch--primary-dark"
                        onClick={this.toggleOpen}
                      >
                        {opened ? "Zwiń" : "Rozwiń"}
                        {
                          <i
                            className={`consultations__icon fas fa-angle-${
                              opened ? "up" : "down"
                            }`}
                          />
                        }
                      </div>
                    </div>
                  </div>

                  {opened &&
                    this.props.projectType === ProjectType.PublicBudget && (
                      <div className="consultations__subtitle consultations__subtitle--center">
                        <i>
                          Zasady przyznawania punktów: maksimum na obszar{" "}
                          {points.maxForDistrict} pkt, na kategorię{" "}
                          {points.maxForCategory} pkt, na projekt{" "}
                          {points.maxForProject} pkt.
                        </i>
                      </div>
                    )}

                  {opened && (
                    <div className="consultations__body">
                      <div className="consultations__item">
                        {this.renderContent()}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {this.props.projectType !== ProjectType.PublicBudget &&
          this.renderContent()}
      </React.Fragment>
    );
  }
}

ConsultationForm.propTypes = {
  categoryPointDivision: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.number,
  index: PropTypes.number,
  isResultPublished: PropTypes.bool,
  loggedUserId: PropTypes.number,
  maxPoint: PropTypes.number,
  outOfRangeVoteDates: PropTypes.bool,
  prefixName: PropTypes.string,
  projectType: PropTypes.number,
  publishType: PropTypes.number,
  rowId: PropTypes.number,
  shortDescription: PropTypes.string,
  status: PropTypes.number,
  statusName: PropTypes.string,
  type: PropTypes.number,
  voted: PropTypes.bool,
  voteFrom: PropTypes.string,
  voteTo: PropTypes.string,

  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      maxPoint: PropTypes.number,
      title: PropTypes.string,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          canComment: PropTypes.bool,
          content: PropTypes.string,
          id: PropTypes.number,
          order: PropTypes.number,
          maxPoint: PropTypes.number,
          questionOptionCount: PropTypes.number,
          questionResultQuantitySum: PropTypes.number,
          questionType: PropTypes.number,
          answers: PropTypes.arrayOf(
            PropTypes.shape({
              categoryId: PropTypes.number,
              id: PropTypes.number,
              questionId: PropTypes.number,
              userId: PropTypes.number,
              answerOptions: PropTypes.arrayOf(
                PropTypes.shape({
                  comment: PropTypes.string,
                  id: PropTypes.number,
                  openDate: PropTypes.string,
                  openText: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                  ]),
                  questionMatrixValueId: PropTypes.number,
                  questionOptionId: PropTypes.number,
                  ranking: PropTypes.number,
                })
              ),
            })
          ),
          questionMatrixValues: PropTypes.arrayOf(
            PropTypes.shape({
              content: PropTypes.string,
              id: PropTypes.number,
              order: PropTypes.number,
            })
          ),
          questionOptions: PropTypes.arrayOf(
            PropTypes.shape({
              content: PropTypes.string,
              id: PropTypes.number,
              order: PropTypes.number,
            })
          ),
          questionResults: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number,
              quantity: PropTypes.number,
              questionOptionName: PropTypes.string,
            })
          ),
        })
      ),
    })
  ),
};

ConsultationForm.defaultProps = {
  categoryPointDivision: false,
  disabled: false,
  id: 0,
  index: 0,
  isResultPublished: false,
  loggedUserId: 0,
  maxPoint: 0,
  outOfRangeVoteDates: false,
  outOfRangeDistricts: false,
  prefixName: "",
  projectType: 0,
  publishType: -1,
  rowId: 0,
  shortDescription: "",
  status: -1,
  statusName: "",
  type: 0,
  voted: false,
  voteFrom: moment().format("YYYY-MM-DD"),
  voteTo: moment().format("YYYY-MM-DD"),
  agreementAccepted: false,
  agreementAcceptedRequired: false,
  expand: {
    budgets: [],
    oldbudgets: [],
    consultations: [],
    oldconsultations: [],
    surveys: [],
    oldsurveys: [],
    probes: [],
    oldprobes: [],
  },
  answers: [],
  attachments: [],
  categories: [],
  isExecuting: false,
};
